import axios from 'axios';
import toast from 'react-hot-toast';

import { apiUrl } from '../apiUrl';
import i18n from '../../i18n';

export const fetchAcademy = async ({ franchiseId }) => {
  try {
    const response = await axios.get(
      `${apiUrl}/newSummerplay/${franchiseId}/academy_groups`,
    );

    return response.data.summerplay_groups || [];
  } catch (error) {
    toast.error(
      i18n.t('apiErrors.academyGroups'),
    );

    return [];
  }
};
